import React, {useEffect} from 'react';
import {useIsAuthenticated, useMsal} from '@azure/msal-react';
import {EventMessage, EventType, InteractionStatus} from '@azure/msal-browser';
import {useSnackbar} from 'notistack';
import {useObservable} from '@ngneat/react-rxjs';

import {sessionQuery, sessionService} from '@store/session';

import {msalLoginRequest} from '@config/azure.config';

import LoadingScreen from '@screens/loading/Loading.screen';
import Admin from '@screens/admin/Admin';
import { Button } from '@mui/material';

const Routes = () => {
  const {enqueueSnackbar} = useSnackbar();
  const {instance, inProgress} = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const [{currentUser, loading}] = useObservable(sessionQuery.currentUser$);
  const [hasAccessToAdmin] = useObservable(sessionQuery.hasAccessToAdmin$());

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      if (isAuthenticated) {
        sessionService.getCurrentUser().subscribe({
          error: (err) => enqueueSnackbar(err.text, err.options),
        });
      } else {
        instance.loginRedirect(msalLoginRequest).catch((e) => {
          console.error(e);
        });
      }
    }

    const _msalEvent = instance.addEventCallback(async (message: EventMessage) => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        sessionService.getCurrentUser().subscribe();
      }
    });

    return () => {
      if (_msalEvent) instance.removeEventCallback(_msalEvent);
    };
  }, [enqueueSnackbar, inProgress, instance, isAuthenticated]);

  if (!currentUser || inProgress !== InteractionStatus.None || loading) return <LoadingScreen/>;

  if (hasAccessToAdmin) {
    return <Admin/>;
  } else {
    return <>
      No access
      <Button variant="contained" onClick={() => sessionService.logout()}>
        Logout
      </Button>
    </>;
  }
};

export default Routes;
